module.exports = __webpack_public_path__ + "static/media/my-workspace.bce1e620.png";